<template>
    <div class="search-result-top">
        <div aria-live="polite" class="page-status">
            <ResultsPageStatus />
        </div>
        <ResultsSortBy class="sort-by" />
    </div>    
</template>

<style scoped lang="scss">

.search-result-top {
    display: flex;

    //Push the SortBy to the end.
    .page-status {
      flex-grow: 1;
    }

    .sort-by {
      align-self: center;
    }
  }

</style>